<template>
    <DatePicker
        :id="id"
        v-model="date"
        mode="date"
        :disabled-dates="disabledDates"
        :attributes="attrs"
        :format="format"
        :required="isRequired"
        :popover="{ visibility: isDisabled ? 'hidden' : 'focus' }"
        @dayclick="update(date)"
    >
        <template #default="{ inputValue, inputEvents }">
            <div style="display:flex; justify-content:start; align-items:center; margin:0; gap:0.5rem">
                <input
                    class="form-control"
                    style="min-width:80%"
                    :name="name"
                    type="text"
                    :value="inputValue"
                    v-on="inputEvents"
                    :required="isRequired"
                    :format="format"
                    :disabled="isDisabled"
                    autocomplete="off"
                />
            </div>
        </template>
        <template #footer>
            <div style="width: 100%; text-align: center">
                <button
                    type="button"
                    class="button button-primary today-button"
                    style="width: 90%; margin:1rem;"
                    @click.prevent="setValueAsToday"
                >
                    Today
                </button>
            </div>
        </template>
    </DatePicker>
</template>

<script>
import { ref } from 'vue';
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';

const attrs = ref([
    {
        key: 'today',
        highlight: 'red',
        dates: new Date(),
    },
]);

export default {
    components: {
        DatePicker,
    },

    props: {
        id: String,
        name: String,
        value: String,
        format: String,
        disableDatesTo: String,
        disableDatesFrom: String,
        clearButton: Boolean,
        isRequired: Boolean,
        shouldEmitEvent: Boolean,
        isDisabled: { type: Boolean, default: false },
    },

    data() {
        return {
            date: '',
            defaultDate: '',
            disabledDates: [],
            attrs: attrs,
        };
    },

    created() {
        if (this.value) {
            const date = this.value === 'today'
                ? this.getToday()
                : this.getDateFromString(this.value);

            this.setDate(date);
            this.defaultDate = date
        }

        if (this.disableDatesTo) {
            this.disabledDates.to = this.getDateFromString(this.disableDatesTo);
        }

        if (this.disableDatesFrom) {
            this.disabledDates.from = this.getDateFromString(this.disableDatesFrom);
        }

        const eventName = 'set' + this.name.replace(/^\w/, c => c.toUpperCase());

        window.events.on(eventName, value => {
            this.setDate(value);
        });
    },

    methods: {
        getDate(day, month, year) {
            return new Date(year, month, day);
        },

        getDateFromString(date, separator = '/') {
            const parts = date.split(separator);
            return this.getDate(parts[0], parts[1] - 1, parts[2]);
        },

        getToday() {
            return new Date();
        },

        setValueAsToday() {
            this.setDate(this.getToday());
            this.update(this.getToday(), this.defaultDate);
        },

        clearInput() {
            this.setDate('');
        },

        setDate(date) {
            this.date = date;
        },

        update(date, defaultDate) {
            this.broadcast(date, defaultDate);
        },

        broadcast(date) {
            if (this.shouldEmitEvent) {
                const name = 'update' + this.name.replace(/^\w/, c => c.toUpperCase());
                const value = [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-');
                window.events.emit(name, value);
            }
        }
    }
}
</script>
